import {routes} from '@/router';
import {RouteMeta} from 'vue-router';


export interface ModuleAction {
  name: string;
  to: RouteMeta & {name: string};
  color?: string;
}

export interface DashboardModule {
  name: string;
  desc: string;
  color: string;
  icon: string;
  hideInNav: boolean;
  badgeContent: string | number | null;
  actions?: ModuleAction[];
  outlined?: boolean;
}

export function generateModule(name: string, options: Partial<DashboardModule> = {}): DashboardModule {
  const route = routes.find((route) => route.name === name);
  return {
    name: route?.meta?.title as string ?? name,
    desc: route?.meta?.desc as string ?? '',
    color: 'primary',
    icon: route?.meta?.icon as string ?? '',
    actions: [{name: 'Öffnen', to: {name: name}}],
    get hideInNav() {
      return route?.meta?.hideInNav as boolean ?? false;
    },
    get badgeContent() {
      return route?.meta?.badgeContent as string | number ?? null;
    },
    ...options,
  };
}
